import { Settings2, ToggleLeft } from 'lucide-react';
import { Trans, useTranslation } from 'react-i18next';

import type { ReactElement } from 'react';

export const DeviceDisabledInstruction = ({
  mediaType,
}: {
  mediaType: 'video' | 'audio' | 'camera-and-microphone';
}): ReactElement => {
  const { t } = useTranslation();
  return (
    <section className="flex flex-col gap-4">
      {mediaType === 'camera-and-microphone'
        ? t('permissions.media.disabled.titleBoth')
        : t('permissions.media.disabled.titleMedia', { mediaType: t(`media.${mediaType}`) })}

      {t('permissions.media.disabled.toUnblock')}
      <ol className="flex list-disc flex-col gap-2 pl-6">
        <li>
          <Trans i18nKey="permissions.media.disabled.instructionsLine1">
            Click the <Settings2 className="mx-1 inline h-5 w-5 self-end" /> icon in the top left of the browser next to
            the Askable website URL
          </Trans>
        </li>
        <li>
          <Trans
            i18nKey="permissions.media.disabled.instructionsLine2"
            values={{
              mediaType: mediaType === 'camera-and-microphone' ? t('media.both') : t(`media.${mediaType}`),
            }}
          >
            Click the <ToggleLeft className="mx-1 inline h-5 w-5 self-end" /> toggle for
            {mediaType === 'camera-and-microphone' ? 'both camera and microphone' : mediaType}
          </Trans>
        </li>
      </ol>
    </section>
  );
};
